import { UploaderComponent } from '@syncfusion/ej2-react-inputs';
import * as React from 'react';
import { apiUrl } from '../pages/UrlParam';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AxiosFetchData from '../pages/AxiosFetchData';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PageviewIcon from '@mui/icons-material/Pageview';
import ImageView from '../components/ImageView';
import Bindcomponent from '../utils/bindcomponent';
 
class UploadFile extends React.Component {
    uploadObj;
    listFiles = []
    path= {
        saveUrl: `${apiUrl}/api/UploadFiles`
    }    
 
    dropAreaRef;
    constructor(props) {
        super(props);
        this.state = {
            list :[],
            roleaccess :{
                CREATE : true,
                READ : true,
                UPDATE : true,
                DELETE : true
            },
            path :'',
            isOpen :false,
            filename :''
        }
         this.GetFiles()
     
    }   
async onUploadSuccess(args)  {
    try{
        let data ={
            path : (JSON.parse(args.e.currentTarget.response)).data.file_path,
            description : null,
            type : this.props.type,
            reference_id : this.props.id,
            mime : args.file.rawFile.type,
            file_name : args.file.name
        }
     
        var resp = await AxiosFetchData.post(`AddFiles`,data).refreshToken(this.props.navigate, this.props.table);
        this.setState({roleaccess : resp.roleaccess})
        await this.GetFiles()
    }catch(err){
        alert(err.message)
    }
     
}
async onCreated() {
    await this.GetFiles()
    this.uploadObj.dropArea = this.dropAreaRef;
    this.uploadObj.dataBind();
} 
    
handleClose = val =>{
     
    this.props.handleClose();
       
}

handleImageIcon(row)
{
         if(row.mime.includes('image')){
                return row.path;
         }

         if(row.mime.includes('pdf')){
            return 'uploads/pdf.png';
         }

         if(row.mime.includes('vnd.ms-excel') || row.mime.includes('vnd.openxmlformats-officedocument.spreadsheetml.sheet')){
            return 'uploads/excel.png';
         }

         if(row.mime.includes('msword') || row.mime.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')){
            return 'uploads/word.png';
         }
}
async GetFiles(){
     try{
        var files = await AxiosFetchData.get(`GetFiles/${this.props.id}/${this.props.type}`).refreshToken(this.props.navigate,this.props.table);
        const rows = files.data.map((row, index) => ({
            ...row,
            imageIcon : this.handleImageIcon(row)
          }));
        this.setState({list : rows});
        this.setState({roleaccess : files.roleaccess})
       
     }catch(e){
        console.log(e)
     }
      
}
     

async handleImageClick(id,path){
       try{
            await AxiosFetchData.delete(`DeleteFiles/${id}/${encodeURIComponent(path)}`).refreshToken(this.props.navigate,"invoice")
            await this.GetFiles()
        }catch(e){
            alert(e.message)
       }
}
render() {
        return (
            <>
            <Dialog
                open = {this.props.productopen}
                onClose={this.handleClose}
                maxWidth="sm"
                fullWidth
            >
                <form  role="form"> 
                <DialogTitle>UPLOAD DOCUMENT </DialogTitle>
                <DialogContent>
                   
                    <div className='row mb-6'>
                    {this.state.list.length > 0 && (
                    <ImageList sx={{ width: "100%", height: "100%", overflow:'auto' }} cols={5} rowHeight={100}  gap={8} variant='quilted' >
                        {this.state.list.map((item) => (
                            <ImageListItem key={item.id}  >
                              
                                <img
                                    srcSet={`${apiUrl + '/' + item.imageIcon}?w=50&fit=crop&auto=format&dpr=2 2x`}
                                    src={`${apiUrl + '/' + item.imageIcon}?w=50&fit=crop&auto=format`}
                                    alt={item.file_name}  
                                    loading="lazy"
                                 
                                />
                                <ImageListItemBar
                                    subtitle={item.file_name}
                                    position="bottom"
                                    actionPosition="left"
                                />
                                    <ImageListItemBar
                                        position="top"
                                        actionIcon={
                                        <IconButton
                                            sx={{ color: 'white' }}
                                            aria-label={`star ${item.title}`}>
                                            <DeleteOutlineIcon  onClick={async () => await this.handleImageClick(item.id, item.path)} />
                                            <PageviewIcon onClick={() =>{
                                                if(item.mime.includes('image')){
                                                    this.setState({isOpen:true})
                                                    this.setState({path : item.path})
                                                    this.setState({filename : item.file_name})
                                                }else{
                                                    window.open(`${apiUrl}/${item.path}`);
                                                }
                                                   
                                            } 
                                            }></PageviewIcon>
                                        </IconButton>
                                        }
                                        actionPosition="left"
                                    />
                            </ImageListItem>
                        ))}
                    </ImageList>
                    )}
                    
                    </div>
                    <DialogContentText>
                    <h5>only for extension ./jpg, .gif, .png, ./doc, .docx, ./xls, .xlsx, and .pdf</h5>
                    </DialogContentText>
                  
                    <div className='row mb-6'>
                        <div className='col-lg-12'>
                        <div className = 'control-pane'>
                            <div className='control-section row uploadpreview'>
                            <div className='col-lg-12'>
                            <div className='upload_wrapper'>
                            {/* Render Uploader */}
                                <UploaderComponent id='fileUpload' type='file' ref = {upload => {this.uploadObj = upload }} allowedExtensions='.jpg, .png, .gif, .jpeg, .xlsx, .pdf, .xls, .doc'
                                    asyncSettings = {this.path} 
                                    disabled={!this.state.roleaccess.CREATE}
                                    success={ this.onUploadSuccess = this.onUploadSuccess.bind(this)} created={this.onCreated = this.onCreated.bind(this)} 
                                    />
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                   
                </DialogContent>
                <DialogActions>
                    <button className='btn' onClick={this.handleClose} type='button'>CLOSE {this.state.roleaccess.CREATE}</button>
                </DialogActions>
                </form>
                </Dialog>
                
                <Bindcomponent component='ImageView' path={this.state.path} productopen={this} ></Bindcomponent>
                {/* <ImageView path={this.state.path} productopen={this} ></ImageView> */}
            </>
        );
    }
}
 export default  React.memo(UploadFile)